import React, { useMemo } from 'react';
import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography';
import S from '../style/Dac7TabContent';
import { SellerBusinessDac7 } from '../../../../../../typings/dac7';
import { useI18n } from '../../../../../i18n';
import Dac7Dropdown from './Dac7Dropdown';
import countries from '../utils/countriesList';

interface Props {
  permanentEstablishmentCountry: SellerBusinessDac7['permanentEstablishmentCountry'];
}

const Dac7PermanentEstablishment = ({ permanentEstablishmentCountry }: Props) => {
  const i18n = useI18n();
  const memoedIds = useMemo(() => [permanentEstablishmentCountry], [permanentEstablishmentCountry]);

  return (
    <>
      <S.Dac7FormField>
        <Dac7Dropdown
          sourceItems={countries}
          initialSelectedIds={memoedIds}
          name="dac7_permanentEstablishmentCountry"
          label={i18n('dlv_dac7_permanentEstablishmentCountry')}
          required
          requiredMessage={i18n('dlv_dac7_permanentEstablishmentCountryRequired')}
          placeholder={i18n('dlv_dac7_permanentEstablishmentCountryPlaceholder')}
          disabled={!!permanentEstablishmentCountry}
        />
        <Paragraph4 mt={12} color={permanentEstablishmentCountry ? '#7F9799' : '#002F34'}>
          {i18n('dlv_dac7_permanentEstablishmentCountry_description')}
        </Paragraph4>
      </S.Dac7FormField>
    </>
  );
};

export default Dac7PermanentEstablishment;
